<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
<salonmonster-tap-retry
  *ngIf="errorOccurredWhileLoadingServices"
  (click)="loadServices()"
>
</salonmonster-tap-retry>

<ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingServices">
  <ion-row>
    <ion-col class="hidden-sm-down"></ion-col>

    <ion-col size="12" size-sm="12" size-md="8" size-lg="6" size-xl="6">
      <ion-card *ngIf="salonServiceCategories.count() == 0">
        <h2>Salon services</h2>
        <br />
        <p>No services to show</p>
        <ion-button (click)="onAddAction()"> Create a new service </ion-button>
      </ion-card>

      <ng-container *ngIf="salonServiceCategories.count() > 0">
        <div class="ion-padding-start ion-padding-end">
          <ng-container *ngIf="viewMode == 'normal'">
            <h3>Services</h3>
            <ng-container *ngIf="planID > 2"
              >Manage the service categories and services offered by all staff.
            </ng-container>
            <ng-container *ngIf="planID < 3"
              >Manage your service categories and services.
            </ng-container>
          </ng-container>
          <ng-container *ngIf="viewMode !== 'normal'">
            <h3>
              Reorder
              {{
                viewMode == "reorder-services"
                  ? "services"
                  : "service categories"
              }}
            </h3>
            Drag the <ion-icon name="reorder-four-outline"></ion-icon> icon to
            reorder your service categories
          </ng-container>
        </div>
        <ion-row class="ion-no-padding">
          <ion-col size="12">
            <ion-grid>
              <ion-row>
                <ion-col size="6" sizeMd="3">
                  <ion-button
                    *ngIf="!isServiceCategoriesReordering"
                    fill="clear"
                    expand="block"
                    size="small"
                    (click)="enableServiceCategoriesReordering()"
                    class="ion-text-wrap"
                  >
                    Reorder categories
                  </ion-button>
                  <ion-button
                    *ngIf="isServiceCategoriesReordering"
                    expand="block"
                    size="small"
                    (click)="onSaveOrder()"
                    class="ion-text-wrap"
                  >
                    Save categories order
                  </ion-button>
                </ion-col>
                <ion-col size="6" sizeMd="3">
                  <ion-button
                    *ngIf="!isServicesReordering"
                    expand="block"
                    fill="clear"
                    size="small"
                    (click)="enableServicesReordering()"
                    class="ion-text-wrap"
                  >
                    Reorder services
                  </ion-button>
                  <ion-button
                    *ngIf="isServicesReordering"
                    expand="block"
                    size="small"
                    (click)="onSaveOrder()"
                    class="ion-text-wrap"
                  >
                    Save services order
                  </ion-button>
                </ion-col>
                <ion-col size="6" sizeMd="3">
                  <ion-button
                    expand="block"
                    size="small"
                    (click)="enableAddCategory()"
                    class="ion-text-wrap"
                  >
                    + New category
                  </ion-button>
                </ion-col>
                <ion-col size="6" sizeMd="3">
                  <ion-button
                    expand="block"
                    size="small"
                    (click)="onAddAction()"
                    class="ion-text-wrap"
                  >
                    + New service
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
        <ion-list *ngIf="viewMode == 'normal'" class="ion-padding">
          <ion-item-group
            *ngFor="
              let serviceCategory of salonServiceCategories;
              let serviceCategoryIndex = index
            "
          >
            <ion-item-divider
              (click)="onServiceCategorySelect(serviceCategory)"
              color="light"
              tappable
            >
              <ion-label class="category-label">{{
                serviceCategory.categoryName
              }}</ion-label>
            </ion-item-divider>
            <ion-item
              *ngFor="
                let serviceDefinition of serviceCategory.getServiceDefinitions();
                let serviceDefinitionIndex = index
              "
              (click)="editSalonService(serviceDefinition, $event)"
              tappable
            >
              <ion-label>{{ serviceDefinition.name }}</ion-label>
            </ion-item>
          </ion-item-group>
        </ion-list>
        <ion-list *ngIf="viewMode == 'reorder-categories'" class="ion-padding">
          <ion-reorder-group
            disabled="false"
            (ionItemReorder)="reorderServiceCategories($any($event))"
          >
            <ion-item
              *ngFor="
                let serviceCategory of salonServiceCategoriesForReordering;
                let serviceCategoryIndex = index
              "
              color="light"
            >
              <ion-label class="category-label">{{
                serviceCategory.categoryName
              }}</ion-label>
              <ion-reorder slot="end"></ion-reorder>
            </ion-item>
            <!-- <ion-item *ngIf="serviceCategory.getServiceDefinitions().count() == 0">
              <ion-note>No services</ion-note>
            </ion-item>

            <ion-item
              *ngFor="let serviceDefinition of serviceCategory.getServiceDefinitions(); let serviceDefinitionIndex = index;"
            >
              {{ serviceDefinition.name }} 
            
            </ion-item> -->
          </ion-reorder-group>
        </ion-list>

        <ion-list *ngIf="viewMode == 'reorder-services'" class="ion-padding">
          <ng-container
            *ngFor="
              let serviceCategory of salonServiceCategoriesForReordering;
              let serviceCategoryIndex = index
            "
          >
            <ion-item-divider color="light">
              <ion-label class="category-label">{{
                serviceCategory.categoryName
              }}</ion-label>
            </ion-item-divider>
            <ion-reorder-group
              disabled="false"
              (ionItemReorder)="
                reorderServices($any($event), serviceCategoryIndex)
              "
            >
              <!-- <ion-item-divider color="light">{{ serviceCategory.getCategoryName() }}</ion-item-divider> -->
              <!-- <ion-item *ngIf="serviceCategory.getServiceDefinitions().count() == 0">
                <ion-label>No services</ion-label>
              </ion-item> -->
              <ion-item
                *ngFor="
                  let serviceDefinition of serviceCategory.getServiceDefinitions();
                  let serviceDefinitionIndex = index
                "
              >
                {{ serviceDefinition.name }}
                <ion-reorder slot="end"></ion-reorder>
              </ion-item>
            </ion-reorder-group>
          </ng-container>
        </ion-list>
      </ng-container>
    </ion-col>

    <ion-col class="hidden-sm-down"></ion-col>
  </ion-row>
</ng-container>
